import NavigationBar from '@/components/NavigationBar'
import FooterBar from '@/components/FooterBar'
import './index.less'
import React, { useState, useEffect, } from 'react'
import { Outlet, useLocation } from "react-router-dom";



export default function Layout() {
  const [isGrey, setIsGrey] = useState(false);
  const location = useLocation();
  console.log(location.pathname)

  useEffect(() => {
    if ('/info' === location.pathname) {
      setIsGrey(true);
    } else {
      setIsGrey(false);
    }
  })
  const whiteUrl = ['/subOrderForm', '/SubOrderCommit', '/pay', '/orderDetail', '/diningCompleted', '/transferOrderCommit', '/transferOrderDetail']
  const noNavUrl = ['/order', '/transferOrder', '/pay', '/orderDetail', '/diningCompleted', '/transferOrderCommit', '/transferOrderDetail','/SubOrderCommit']
  return (
    <div className='home'>
      <div width="100%">
        <NavigationBar  showNavTabs={noNavUrl.findIndex(item => item === location.pathname) > -1 ? false : true}></NavigationBar>
      </div>

      <div className={"content" + (isGrey ? "-grey" : "")}>
        <Outlet />
      </div>
      {
        whiteUrl.findIndex(item => item === location.pathname) > -1 ? null :
          <FooterBar></FooterBar>
      }

    </div>
  )
}